import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";
import {ZIDXAccountListView} from "../../AccountListView.js";

const $ = jQuery.noConflict();
export class ZIDXAccountSuperAdminPublicUsers implements ZIDXPage {
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass() {
        return "zidxAccountSuperAdminPublicUsersContainer";
    }
    render() {
        let listView=new ZIDXAccountListView(this.zidx);
        listView.render();
        let self=this;
        $(".zidxExportPublicUsersButton", this.zidx.peakidxShadowRoot).on("click", function(){
            self.exportUsers();
        });
    }
    exportUsers() {
        // read the current search fields so the export matches what is on screen, even after an ajax list reload
        let searchForm = $(".zidxSearchListViewForm", this.zidx.peakidxShadowRoot).serializeArray();
        const params = new URLSearchParams();
        for (let field of searchForm)
            if (field.name.startsWith("search"))
                params.append(field.name, field.value);

        window.open(`/account/superadmin/public-users/export?${params.toString()}`);
    }
}
